import clsx from 'clsx'
import { Icon } from '@iconify/react'

import s from './PercentChange.module.css'

type Props = {
  change: number
}

export const PercentChange = ({ change }: Props) => {
  const formattedChange = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 1,
  }).format(Math.abs(change))

  return (
    <div
      className={clsx(s.change, {
        [s.positive]: change > 0,
        [s.negative]: change < 0,
      })}
    >
      {change > 0 ? (
        <Icon icon="lucide:arrow-up-right" width={16} height={16} />
      ) : (
        <Icon icon="lucide:arrow-down-right" width={16} height={16} />
      )}
      {formattedChange}%
    </div>
  )
}
